// extracted by mini-css-extract-plugin
export var reportChartContainer = "report-common-module--report-chart-container--oouXB";
export var reportContainer = "report-common-module--report-container--h18RR";
export var reportControlButton = "report-common-module--report-control-button--TOAiv";
export var reportControls = "report-common-module--report-controls--AcXFH";
export var reportRange = "report-common-module--report-range--K7dIg";
export var reportStatus = "report-common-module--report-status--uBtib";
export var reportTable = "report-common-module--report-table--OpIEb";
export var reportTableContainer = "report-common-module--report-table-container--dx9js";